/* eslint-disable @stylistic/max-len */
import React from 'react';
import propTypes from './propTypes';

const Carrot = ({ className = 'icon', notUseClass = false, style = {} }) => (
  <svg
    className={notUseClass ? '' : className}
    style={{ color: '#696f88', ...style }}
    width="9"
    height="20"
    fill="none"
    viewBox="0 0 9 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M4.3752 19.0296C3.2856 19.0296 2.7792 17.9856 2.1312 16.392C1.632 15.1632 1.104 13.452 0.6792 11.7C0.2472 9.91441 0 8.37841 0 7.48561C0 5.94961 0.9264 5.06161 2.8296 4.77121L3.0144 4.74241L1.2024 1.9776L2.3688 1.2216L3.7032 3.3144V0L5.0496 0.0192001V3.3504L6.264 1.3632L7.4304 2.1192L5.736 4.74241L5.9184 4.77121C7.8216 5.05921 8.748 5.94721 8.748 7.48561C8.748 8.37601 8.5008 9.91201 8.0688 11.7C7.6464 13.4544 7.116 15.1632 6.6168 16.392C5.9712 17.9856 5.4648 19.0296 4.3752 19.0296ZM4.3752 6.14161C2.3616 6.14161 1.5408 6.53041 1.5408 7.48561C1.5408 9.21121 2.7024 14.1576 3.7872 16.488L3.8232 16.5624C4.0824 17.1216 4.2072 17.3496 4.3776 17.3496C4.548 17.3496 4.6728 17.1216 4.932 16.5624L4.9656 16.488C6.0504 14.1576 7.212 9.20881 7.212 7.48561C7.2096 6.53041 6.3888 6.14161 4.3752 6.14161Z" fill="currentColor" />
  </svg>
);

Carrot.propTypes = propTypes;

export default Carrot;
